import { IconComponent } from '../icon.types';

export const LogoIcon: IconComponent = (props) => (
  <svg
    width="170"
    height="118"
    viewBox="0 0 170 118"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M87.0954 24.8196L112.191 23.7573C112.687 23.891 117.436 30.9752 118.397 31.9812C118.675 32.2732 118.636 32.3049 119.125 32.2064L129.693 11.1013H142.013L141.119 20.5845L126.877 41.7037H143.597C144.491 42.9102 147.043 46.2518 146.41 47.6658L126.908 72.1548L48.8879 72.3236C47.3918 72.2955 46.7265 70.4312 46.6174 69.1403H30.7767L31.5195 63.1992L42.7452 61.3982L41.5132 58.5877H31.8328L32.5755 52.9984L38.5316 51.7145L29.418 30.3491L32.0722 27.3487L47.6734 26.5819L48.0817 2.01202L51.3062 0.6226L59.48 6.86267L77.7917 6.55313L83.5823 0L87.0954 1.42811V24.8196ZM54.8298 26.107C58.9097 29.9903 63.7851 23.0925 59.9622 19.7473C55.9035 16.1946 51.2921 22.7407 54.8298 26.107ZM76.4329 18.9137C72.2897 19.8529 73.0149 27.419 77.3799 27.2678C82.8642 27.0778 82.1004 17.6263 76.4329 18.9137ZM68.752 26.2688H66.3618C66.1788 27.0708 66.0485 28.1366 65.5804 28.8225C64.7496 30.0361 62.1341 30.2295 63.507 32.0375C64.6405 33.2862 66.9884 31.5521 67.5692 30.4371C69.6884 31.8581 72.1665 33.6415 72.6664 29.7476C70.2727 29.7054 69.0758 28.6502 68.7555 26.2688H68.752ZM47.3179 49.9698V31.327C47.3179 31.1968 48.0078 30.9963 47.1489 30.4582L33.9413 31.5064L42.7628 51.1939L47.3179 49.9698ZM142.01 45.9247H100.648C100.574 45.9247 100.398 46.2201 100.116 46.1111L99.7679 45.7805C98.7929 44.7111 98.0607 41.2429 96.7793 41.0002L71.9588 41.176L53.3056 69.1438H125.292L142.013 45.9282L142.01 45.9247Z"
      fill="currentColor"
    />
    <path
      d="M147.642 117.33L149.381 86.1791C156.794 85.0571 170.357 87.5123 168.604 97.6533C167.749 102.609 163.261 104.787 158.558 104.319L169.439 109.623C169.586 110.098 169.439 110.552 169.301 111.006C169.069 111.776 166.57 117.01 166.123 117.682C165.83 118.122 165.725 118.09 165.422 117.682L155.386 109.592V116.451C155.386 116.56 155.868 116.95 155.738 117.33H147.642ZM155.386 99.0392C161.381 99.5316 161.782 92.567 155.386 93.4112V99.0392Z"
      fill="currentColor"
    />
    <path
      d="M85.9232 86.158C99.8242 86.1158 100.155 118.565 85.1488 117.7C71.1562 116.891 74.0709 86.1932 85.9232 86.158ZM85.5853 93.1297C82.1355 94.1744 81.9983 106.82 85.0678 108.28C88.588 109.954 90.3163 103.095 90.2917 100.622C90.2671 98.2723 88.9681 92.1026 85.5853 93.1262V93.1297Z"
      fill="currentColor"
    />
    <path
      d="M145.882 86.3761V92.8835C145.882 92.9644 146.551 93.3513 146.058 93.4111L137.081 93.0559V97.6321L144.477 97.2804V103.964L137.085 104.315V110.295L146.061 109.943C146.554 110.003 145.885 110.394 145.885 110.471V117.33H130.749V86.3761H145.885H145.882Z"
      fill="currentColor"
    />
    <path
      d="M75.831 86.0244V93.7629L65.4536 93.0665L65.0558 93.7841L65.2706 96.9322H73.3669L73.7224 103.619L65.6261 103.264L65.9781 117.334H59.8179C59.7087 117.334 59.3215 117.819 58.9414 117.686L58.5858 86.0279H75.8345L75.831 86.0244Z"
      fill="currentColor"
    />
    <path
      d="M113.144 117.682V86.7279C120.375 87.8535 127.514 92.4192 128.277 100.274C129.298 110.724 123.691 117.397 113.144 117.682ZM118.78 109.24C124.719 105.656 123.413 98.2126 118.428 94.4664L118.78 109.24Z"
      fill="currentColor"
    />
    <path
      d="M50.134 112.406V117.682H0.5V112.054L50.134 112.406Z"
      fill="currentColor"
    />
    <path
      d="M36.0147 86.0631L37.2854 97.284C38.1267 96.1619 38.8308 91.4977 40.1051 91.2796C42.6079 90.8575 42.3368 95.7609 43.7942 96.9252L45.5613 86.0244L51.19 86.3727L45.9309 106.968L42.0517 107.108C41.6293 105.093 41.2209 102.926 40.6401 100.956C40.4888 100.443 40.8443 100.344 39.9291 100.439L38.1338 107.087L33.5963 107.119L30.4247 86.3727L36.0182 86.0561L36.0147 86.0631Z"
      fill="currentColor"
    />
    <path
      d="M15.9887 107.129H10.3565L6.1323 95.8734V107.129H1.2041L1.55612 86.0243H7.71636L11.0605 95.1699V85.6726C11.9757 85.8274 14.5384 85.2012 14.8834 86.2495L15.9887 107.129Z"
      fill="currentColor"
    />
    <path
      d="M104.344 86.0244L103.992 111.351H110.504L110.93 111.868C110.49 112.93 111.043 113.894 111.05 115.026C111.057 115.951 111.275 117.095 110.504 117.682H98.0078V86.0244H104.344Z"
      fill="currentColor"
    />
    <path
      d="M28.6612 86.0244V90.9489L22.6699 90.8012V93.7665C27.8058 93.4253 28.3197 92.173 27.6051 97.9875H23.0254L22.6769 102.205L28.6612 101.857V107.133H18.4528V86.5556L18.9667 86.1124C22.0327 86.5028 25.6409 86.6576 28.6612 86.0279V86.0244Z"
      fill="currentColor"
    />
  </svg>
);
